import { Suspense, lazy } from 'react';
import { Switch, BrowserRouter as Router, Route, Redirect } from 'react-router-dom';

import Auth from 'utils/Auth';

const { isAuthenticated } = Auth;

const routes = [
  {
    path: '/',
    component: lazy(() => import('../pages/Sites')),
    type: 'private'
  },
  {
    path: '/users',
    component: lazy(() => import('../pages/Users')),
    type: 'private'
  },
  {
    path: '/login',
    component: lazy(() => import('../pages/Login')),
    type: 'public'
  },
  {
    path: '/create-password',
    component: lazy(() => import('../pages/ResetPassword')),
    type: 'public'
  },
  {
    path: '/forgot-password',
    component: lazy(() => import('../pages/ForgotPassword')),
    type: 'public'
  },
  {
    path: '/site/:id',
    component: lazy(() => import('../pages/SiteDetails')),
    type: 'private'
  },
  {
    path: '/compare-sites',
    component: lazy(() => import('../pages/CompareDataPage')),
    type: 'private'
  }
];

const renderRoute = ({ component: Component, ...route }) => {
  return (
    <Route key={route.path} exact path={route.path}>
      {route.type === 'private' && !isAuthenticated() ? (
        <Redirect to="/login" />
      ) : (
        <Suspense fallback={<></>}>
          <Component />
        </Suspense>
      )}
    </Route>
  );
};

const AllRoutes = () => routes.map((route) => renderRoute(route));

const Routes = () => {
  return (
    <Router>
      <Switch>
        <AllRoutes />
      </Switch>
    </Router>
  );
};

export default Routes;
